// extracted by mini-css-extract-plugin
var _1 = "assets-js-ViewInvitation-components-Guestlist-Avatar-module__avatarContainer__C_tQF";
var _2 = "assets-js-ViewInvitation-components-Guestlist-Avatar-module__avatarImg__uzhdc";
var _3 = "assets-js-ViewInvitation-components-Guestlist-Avatar-module__badge__Jbfi_";
var _4 = "assets-js-ViewInvitation-components-Guestlist-Avatar-module__button__8KBRm";
var _5 = "assets-js-ViewInvitation-components-Guestlist-Avatar-module__dropShadow__G5JdX";
var _6 = "assets-js-ViewInvitation-components-Guestlist-Avatar-module__hasDropShadow__aMWMv";
var _7 = "assets-js-ViewInvitation-components-Guestlist-Avatar-module__initials__gkyXQ";
export { _1 as "avatarContainer", _2 as "avatarImg", _3 as "badge", _4 as "button", _5 as "dropShadow", _6 as "hasDropShadow", _7 as "initials" }
